import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "reset-password-group" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"side\"><div class=\"side-text-wrap\"><div class=\"welcome-text\">WELCOME BACK</div><a href=\"/\"><img class=\"logo\" src=\"/images/auth/login-logo.png\" alt=\"\"></a></div></div>", 1)
const _hoisted_3 = { class: "form-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mobile-logo",
    src: "/images/auth/login-logo.png",
    alt: ""
  })
], -1)
const _hoisted_5 = { class: "text-dark auth-language-dropdown" }

import { useStore } from "@/store";
import { ref, onMounted, provide } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import EmailForm from "./2FA/EmailForm.vue";
import CodeForm from "./2FA/CodeForm.vue";
import PasswordForm from "./2FA/PasswordForm.vue";
import LanguageDropdown from "../../components/LanguageDropdown.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'OneTimeCode',
  setup(__props) {

const store = useStore();
const step = ref(0);

const components = {
  EmailForm,
  CodeForm,
  PasswordForm,
};

const data = ref({
  email: "",
  code: "",
});

provide("data", data);
provide("step", step);

const getComponent = () => {
  return components[Object.keys(components)[step.value]];
};
onMounted(() => {
  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(LanguageDropdown)
      ]),
      _createElementVNode("div", null, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(getComponent())))
      ])
    ])
  ]))
}
}

})